import {ILobbyGameInfoPreviewService} from './lobby-game-info-preview.service.interface';
import {action, observable} from 'mobx';
import {ServiceBase} from '../ServiceBase';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {GameInfo} from '../games/game-info';

const TIME_TO_HANDLE_SET_GAME_PREVIEW = 800;
const TIME_TO_HANDLE_CLEAR_GAME_PREVIEW = 5000;


export class LobbyGameInfoPreviewService extends ServiceBase implements ILobbyGameInfoPreviewService {

    constructor(serviceFactory: IServiceFactoryExtended) {
        super(serviceFactory);
        this.reaction(() => this.services.device.isMobile,
            () => this._resetGamePreview());

        this.reaction(() => this.services.routing.currentRoute,
            () => this._resetGamePreview());
    }


    @observable.ref currentPreviewedGame: GameInfo = null;

    @action.bound
    private _setCurrentPreviewedGame(gameType: number | null): void {
        if (gameType) {
            this.currentPreviewedGame = this.services.games.gamesMap[gameType];
        } else {
            this.currentPreviewedGame = null;
        }

    }


    private _setGamePreviewTimeout;
    private _clearGamePreviewTimeout;


    enableGamePreview(): void {
        this._allowPreview = true;
    }

    disableGamePreview(): void {
        this._allowPreview = false;
    }

    private _allowPreview = false;
    get allowGamePreview(): boolean {
        return this._allowPreview && !this.services.device.isMobile;
    }

    private _currentGamePreviewPinned = false;

    pinCurrentGamePreview() {
        this._currentGamePreviewPinned = true;
        clearTimeout(this._clearGamePreviewTimeout);
    }

    unPinCurrentGamePreview() {
        this._currentGamePreviewPinned = false;
        // basically when unPinCurrentGamePreview is called it means user mouse leave from the game preview
        this.clearGamePreview();
    }


    public setGamePreview(gameType: number): void {
        if(!this.allowGamePreview) {
            return;
        }
        clearTimeout(this._clearGamePreviewTimeout);
        clearTimeout(this._setGamePreviewTimeout);
        this._setGamePreviewTimeout = setTimeout(() => {
            this._setCurrentPreviewedGame(gameType);
        }, TIME_TO_HANDLE_SET_GAME_PREVIEW);
    }

    public clearGamePreview(): void {
        if(!this.allowGamePreview) {
            return;
        }

        clearTimeout(this._setGamePreviewTimeout);
        clearTimeout(this._clearGamePreviewTimeout);
        this._clearGamePreviewTimeout = setTimeout(() => {
            !this._currentGamePreviewPinned && this._setCurrentPreviewedGame(null);
        }, TIME_TO_HANDLE_CLEAR_GAME_PREVIEW);
    }

    private _resetGamePreview() {
        clearTimeout(this._setGamePreviewTimeout);
        clearTimeout(this._clearGamePreviewTimeout);
        this._setCurrentPreviewedGame(null);
    }


}
